import { AlertTriangle, TrendingUp, UserCheck, Users } from 'lucide-react';
import type { TeamLevelSummaryDto } from '../../../../domain/contracts/api.contracts';
import { useTranslation } from '../../../../application/hooks/useTranslation';
import { AmountDisplay } from '../../../components/ui/AmountDisplay';

/** KPI strip recomputed for the focused branch (PRD 7.5.1 A). */
export function BranchKpiStrip({ summary }: { summary: TeamLevelSummaryDto | undefined }) {
  const { t } = useTranslation();
  const s = summary ?? { totalMembers: 0, activeClients: 0, activeVolumeBDT: 0, needsAttentionCount: 0 };
  const tiles = [
    { key: 'members', icon: <Users size={14} />, tone: 'emerald', value: <span className="tabular">{s.totalMembers}</span> },
    { key: 'clients', icon: <UserCheck size={14} />, tone: 'blue', value: <span className="tabular">{s.activeClients}</span> },
    { key: 'volume', icon: <TrendingUp size={14} />, tone: 'gold', value: <AmountDisplay amount={s.activeVolumeBDT} bold /> },
    {
      key: 'attention',
      icon: <AlertTriangle size={14} />,
      tone: s.needsAttentionCount > 0 ? 'red' : 'slate',
      value: <span className="tabular">{s.needsAttentionCount}</span>,
    },
  ];
  const label: Record<string, string> = { members: 'Members', clients: 'Clients', volume: 'Volume', attention: 'Attention' };
  return (
    <div className="tm-kpis" data-testid="team-kpi">
      {tiles.map((tile) => (
        <div key={tile.key} className={`tm-kpi tm-kpi--${tile.tone}`}>
          <span className="tm-kpi-top">
            <span className="tm-kpi-label">{t(`team.kpi${label[tile.key]}`)}</span>
            <span className="tm-kpi-icon" aria-hidden>{tile.icon}</span>
          </span>
          <span className="tm-kpi-value">{tile.value}</span>
          <span className="tm-kpi-sub">{t(`team.kpi${label[tile.key]}Sub`)}</span>
        </div>
      ))}
    </div>
  );
}
